import React from 'react';
export function ProblemSection() {
  return <section className="py-20 bg-[#0a0a0a] text-gray-300" data-id="element-157">
      <div className="max-w-4xl mx-auto px-5 md:px-8 text-center md:text-lg space-y-6 font-light leading-relaxed" data-id="element-158">
        <h2 className="text-3xl md:text-4xl font-poppins font-bold text-white mb-10 text-center leading-tight" data-id="element-159">
          ¿Alguna vez has sentido que hay algo dentro de ti…{' '}
          <span className="text-amber-500" data-id="element-160">esperando ser comprendido?</span>
        </h2>

        <p data-id="element-161">No sabes explicarlo con palabras. Pero lo sientes.</p>
        <p data-id="element-162">Como si hubiera una parte de ti que observa. Que intuye.</p>
        <p data-id="element-163">
          Que sabe que la vida no puede reducirse solo a rutina, cansancio,
          obligaciones y ruido mental.
        </p>

        <div className="py-8" data-id="element-164">
          <div className="h-px w-24 bg-gradient-to-r from-transparent via-amber-500/50 to-transparent mx-auto" data-id="element-165"></div>
        </div>

        <p data-id="element-166">
          Durante siglos, las grandes tradiciones espirituales hablaron de esa
          dimensión interior.
        </p>
        <p className="text-amber-400 font-medium tracking-wide" data-id="element-167">
          La llamaron luz. Energía vital. Alma. Conciencia. Centro. Despertar.
        </p>
        <p data-id="element-168">
          Hablaron de los chakras, de la glándula pineal, de la geometría
          sagrada, de los símbolos antiguos y del ser humano como un reflejo
          vivo del universo.
        </p>

        <div className="bg-white/5 border border-white/10 p-8 rounded-2xl my-12 shadow-xl backdrop-blur-sm" data-id="element-169">
          <h3 className="text-xl md:text-2xl font-poppins font-bold text-white mb-6 text-center" data-id="element-170">
            Pero casi siempre ese conocimiento llegó hasta nosotros de forma
            fragmentada.
          </h3>
          <ul className="space-y-4 text-left max-w-2xl mx-auto" data-id="element-171">
            <li className="flex items-start" data-id="element-172">
              <span className="text-amber-500 mr-3 mt-1" data-id="element-173">✦</span>
              <span data-id="element-174">
                Un concepto aquí. Un símbolo allá. Una teoría difícil de
                entender.
              </span>
            </li>
            <li className="flex items-start" data-id="element-175">
              <span className="text-amber-500 mr-3 mt-1" data-id="element-176">✦</span>
              <span data-id="element-177">
                Una promesa vacía. Una explicación demasiado mística… o
                demasiado fría.
              </span>
            </li>
          </ul>
        </div>

        <p className="text-xl text-white font-medium" data-id="element-178">
          Y entonces aparece la confusión.
        </p>
        <p data-id="element-179">Lees. Buscas. Escuchas. Sientes que algo resuena.</p>
        <p className="text-amber-500 font-medium" data-id="element-180">
          Pero aún no logras unir las piezas.
        </p>

        <div className="py-8" data-id="element-181">
          <div className="h-px w-24 bg-gradient-to-r from-transparent via-amber-500/50 to-transparent mx-auto" data-id="element-182"></div>
        </div>

        <p data-id="element-183">
          Y tal vez por eso has sentido, más de una vez, que hay una verdad más
          profunda detrás de lo que vives.
        </p>
        <p className="text-xl text-white italic" data-id="element-184">
          Una verdad que no se impone. Se revela. Poco a poco. En silencio.
        </p>
        <p className="text-2xl font-poppins font-bold text-amber-500 mt-6" data-id="element-185">
          Cuando empiezas a mirar hacia dentro.
        </p>
      </div>
    </section>;
}